import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  GET_CURRENT_COMPANY_SELECTED
} from "./actionTypes"

export const loginUser = (user, history, isFrom, id) => {
  return {
    type: LOGIN_USER,
    payload: { user, history, isFrom, id},
  }
}

export const loginSuccess = user => {
  return {
    type: LOGIN_SUCCESS,
    payload: user,
  }
}

export const logoutUser = history => {
  return {
    type: LOGOUT_USER,
    payload: { history },
  }
}

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
    payload: {},
  }
}

export const apiError = error => {
  return {
    type: API_ERROR,
    payload: error,
  }
}

export const getCurrentCompnaySelected = id => {
  return {
    type: GET_CURRENT_COMPANY_SELECTED,
    payload: id,
  }
}